import { render } from "./MaterialPage.vue?vue&type=template&id=219b9c36&scoped=true"
import script from "./MaterialPage.vue?vue&type=script&lang=js"
export * from "./MaterialPage.vue?vue&type=script&lang=js"

import "./MaterialPage.vue?vue&type=style&index=0&id=219b9c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219b9c36"]])

export default __exports__